import { Row, RowProps } from 'react-aria-components'

import { joinStyles } from 'app/utils/theme'

import * as styles from './index.css'

type TableFooterProperties<T> = RowProps<T> & {
    className?: string
}

export const TableFooter = <T extends object>({
    className,
    ...properties
}: Readonly<TableFooterProperties<T>>): JSX.Element => {
    return (
        <Row
            className={joinStyles(styles.root, className)}
            {...properties}
        />
    )
}
